import Login from './Pages/Login'
import Dashboard from './Pages/Dashboard'
import Service from './Pages/Services'
import Category from './Pages/Category'
import Profile from './Pages/Profile'
import Orders from './Pages/Orders'
import Priority from './Pages/Priority'
import Promocode from './Pages/Promocode'
import Transaction from './Pages/Transaction'
import Header from './Pages/Header'
import Days from './Pages/Days'
import Price from './Pages/Price'
import Users from './Pages/Users'
import Quotation from './Pages/Quotation'
import ReQuotation from './Pages/ReQuotation'
import CreateTenant from './Pages/CreateTenant'
import Notification from './Pages/Notification'
import Settings from './Pages/Settings'
import TenantUsers from './Pages/tenantUsers'
import OutsideUsers from './Pages/outsideUsers'
import Feedback from './Pages/Feedback'
import ExpiringSoon from './Pages/ExpiringSoon'
// import GetURLParams from './Pages/GetURLParams'
import Callback from './Pages/Callback'

import Success from './Pages/Success'
import Failed from './Pages/Failed'
import Pending from './Pages/Pending'



// import MAP from './Pages/LocationPicker'

// import MAP from './Pages/ReactGeocode'

// import MAP from './Pages/ReactGoogleLocation'

import MAP from './Pages/LocationAutoComplete'





import React from "react";
import { Offline, Online } from "react-detect-offline";

import logo from './Pages/assets/img/brand/blue.png'
import wifi from './Pages/assets/img/brand/wifi.gif'

import {
    BrowserRouter as Router,
    Switch,
    Route,
    HashRouter,
} from "react-router-dom";
import animationData from './Pages/817-no-internet-connection.json'
import Lottie from 'react-lottie';

const he = "100vh"
const wi = "108%"
const OfflineView = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return(
        <div style={{ height: "100vh", display: 'flex', backgroundColor: "#FCFDFF" }}>
            <div style={{ flex: 1, display: 'flex', justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <div>
                    <Lottie options={defaultOptions}
                        height={200}
                        width={400}
                    />


                </div>
                <div>No Internet , Please check your connection</div>
                <br />
                <div>
                    <img style={{ height: 50, width: 50 }} src={logo} />

                </div>
            </div>
        </div>
    )
}
export default class App extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        const polling = {
            enabled: true,
            //url: "https://google.com/",
            interval: 24000,
            timeout: 24000
        };
        const offlinepolling = {
            enabled: true,
            //url: "https://google.com/",
            interval: 31900,
            timeout: 31900
        };
        return (
            <div>
                <Online polling={polling}>
                    <HashRouter>
                        <Router>
                            <div>
                                {/* A <Switch> looks through its children <Route>s and
                                renders the first one that matches the current URL. */}
                                <Switch>
                                    <Route exact path="/login"><Login /></Route>
                                    <Route exact path="/service"> <Service /></Route>
                                    <Route exact path="/category"><Category /></Route>
                                    <Route exact path="/profile"><Profile /></Route>
                                    <Route exact path="/allusers"><Users /></Route>
                                    <Route exact path="/tenant"><CreateTenant /></Route>
                                    <Route exact path="/orders"><Orders /></Route>
                                    <Route exact path="/priority"><Priority /></Route>
                                    <Route exact path="/promocode"><Promocode /></Route>
                                    <Route exact path="/transaction"><Transaction /></Route>
                                    <Route exact path="/header"><Header /></Route>
                                    <Route exact path="/days"><Days /></Route>
                                    <Route exact path="/price"><Price /></Route>
                                    <Route exact path="/quotation"><Quotation /></Route>
                                    <Route exact path="/requotation"><ReQuotation /></Route>
                                    <Route exact path="/notificaion"><Notification /></Route>
                                    <Route exact path="/settings"><Settings /></Route>
                                    <Route exact path="/users"><TenantUsers /></Route>
                                    <Route exact path="/user"><OutsideUsers /></Route>
                                    <Route exact path="/exsoon"><ExpiringSoon /></Route>
                                    <Route exact path="/feedback"><Feedback /></Route>

                                    {/* <Route path="/payto/:userId/:price" component={GetURLParams}/> */}

                                    <Route path="/payment/success" component={Success} />
                                    <Route path="/payment/failed" component={Failed} />
                                    <Route path="/payment/pending" component={Pending} />

                                    <Route path="/payment/callback" component={Callback} />


                                    <Route path="/location" component={MAP} />


                                    <Route exact path="/" component={Dashboard} /> should declare last else switch not work well

                                </Switch>
                            </div>
                        </Router>
                    </HashRouter>
                </Online>

                <Offline polling={offlinepolling}>
                    <HashRouter>
                        <Router>
                            <div>
                                <Switch>
                                    <Route exact path="/login"><OfflineView /></Route>
                                    <Route exact path="/service"> <OfflineView /></Route>
                                    <Route exact path="/category"><OfflineView /></Route>
                                    <Route exact path="/profile"><OfflineView /></Route>
                                    <Route exact path="/allusers"><OfflineView /></Route>
                                    <Route exact path="/tenant"><OfflineView /></Route>
                                    <Route exact path="/orders"><OfflineView /></Route>
                                    <Route exact path="/priority"><OfflineView /></Route>
                                    <Route exact path="/promocode"><OfflineView /></Route>
                                    <Route exact path="/transaction"><OfflineView /></Route>
                                    <Route exact path="/header"><Header /></Route>
                                    <Route exact path="/days"><OfflineView /></Route>
                                    <Route exact path="/price"><OfflineView /></Route>
                                    <Route exact path="/quotation"><OfflineView /></Route>
                                    <Route exact path="/requotation"><OfflineView /></Route>
                                    <Route exact path="/notificaion"><OfflineView /></Route>
                                    <Route exact path="/settings"><OfflineView /></Route>
                                    <Route exact path="/users"><OfflineView /></Route>
                                    <Route exact path="/user"><OfflineView /></Route>
                                    <Route exact path="/exsoon"><OfflineView /></Route>
                                    <Route exact path="/feedback"><OfflineView /></Route>
                                    <Route path="/payment/success" component={Success} />
                                    <Route path="/payment/failed" component={Failed} />
                                    <Route path="/payment/pending" component={Pending} />
                                    <Route path="/payment/callback" component={Callback} />
                                    <Route path="/location" component={OfflineView} />
                                    <Route exact path="/" component={OfflineView} /> should declare last else switch not work well
                                </Switch>
                            </div>
                        </Router>
                    </HashRouter>
                </Offline>
            </div>
        );
    }
}
